import Image from "next/image";
import { MenuItemProps } from "../Utils/constants";
import { useUserStore } from "@/stores/useUserStore";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import axios from "axios";
import { getNewToken } from "@/lib/Definitions";
import { OrderDetailItem } from "@/lib/constants";
import OrderDetail from "./OrderDetail";


const status_list = [
  {
    'name': 'All',
    'value': null,
  },
  {
    'name': 'Not Paid Yet',
    'value': 'draft',
  },
  {
    'name': 'Packed Up',
    'value': 'processing',
  },
  {
    'name': 'Shipped',
    'value': 'shipped',
  },
  {
    'name': 'Delivered',
    'value': 'delivered',
  },
  {
    'name': 'Cancelled',
    'value': 'cancel',
  },
]

const MyOrders = (props: MenuItemProps) => {
  const { userInfo, getUser, updateUser } = useUserStore();
  const [userData, setUserData] = useState(getUser());
  const [isLoading, setIsLoading] = useState(false);
  const [query, setQuery] = useState(true);
  const [page, setPage] = useState(1);
  const [orders, setOrders] = useState<Array<OrderDetailItem>>([]);
  const [selectedStatus, setSelectedStatus] = useState(status_list[0].value);
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
  });

  useEffect(() => {
    const get_order = async () => {
      const start = (page - 1) * 5;
      const end = page * 5;

      try {
        const response = await axios.get(
          "/api/order",
          {
            headers: { 'Authorization': 'Bear ' + userData.token },
            params: {
              start: start,
              end: end,
              status: selectedStatus,
            }
          }
        )

        if (response.data.status === "ok") {
          setOrders(orders.concat(response.data.data));
          setPage(page + 1);

          if (response.data.data.length < 5) {
            setQuery(false);
          }
        }

        setIsLoading(false);
      } catch (error: any) {
        if (error.response.data.error === "Invalid credentials") {
          const response: any = await getNewToken(userData.token, userData.refresh_token, userData.uuid);

          if (response !== "") {
            userData.token = response.token;
            userData.refresh_token = response.refresh_token;
            updateUser(userData);
            get_order();
          }
        }
      }
    }

    if (query && inView && !isLoading) {
      setIsLoading(true);
      get_order();
    }
  }, [inView, isLoading, orders, page, query, selectedStatus, updateUser, userData])

  const handleClick = (status: string | null) => {
    if (status !== selectedStatus) {
      setQuery(true);
      setPage(1);
      setOrders([]);
      setSelectedStatus(status);
    }
  }

  useEffect(() => {
    setUserData(getUser());
  }, [getUser, userInfo])

  return (
    <div className="w-full">
      <div className="flex items-center space-x-4">
        <div>
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/user-purchase-icon.png"}
            alt="Account Detail icon"
            width={20}
            height={20}
            quality={100}
            className="hidden md:block"
          />
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/arrow-right.svg"}
            alt="left arrow icon"
            width={24}
            height={24}
            quality={100}
            className="rotate-180 md:hidden"
            onClick={() => props.setSelected("")}
          />
        </div>
        <p className="text-base text-[#2C3E2F] font-dmsans font-bold">My Purchase</p>
      </div>
      <div className="flex space-x-6 my-6 overflow-x-auto">
        {status_list.map((status, index) => (
          <button
            key={index}
            className={`px-4 py-2 border-solid flex items-center justify-center whitespace-nowrap text-sm text-[#2C3E2F] ${selectedStatus === status.value ? "font-bold border-2 border-[#2C3E2F]" : "font-normal border border-[#C6C6C6]"} hover:border-[#2C3E2F] hover:text-[#2C3E2F]`}
            onClick={() => handleClick(status.value)}
          >
            {status.name}
          </button>
        ))}
      </div>
      <hr className="w-full my-6 h-[1px] bg-[#C6C6C6]" />
      <div className="w-full overflow-y-auto max-h-[600px] px-3 pb-6">
        {
          orders.map((order, index) => (
            <OrderDetail key={index} order={order} />
          ))
        }
        <div ref={ref}></div>
      </div>
    </div>
  )
}

export default MyOrders
